import axios from "axios";

function getStreetAddress(addressComponents) {
  // Extract street-level details like street number, route, etc.
  const streetNumber = addressComponents.find((comp) =>
    comp.types.includes("street_number")
  )?.long_name;

  const route = addressComponents.find((comp) =>
    comp.types.includes("route")
  )?.long_name;

  // Combine street number and route if both exist
  if (streetNumber && route) {
    return `${streetNumber} ${route}`;
  }
  // Return route or street number if only one exists
  return route || streetNumber || null;
}

async function GetAddressDetails(lat, lng) {

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // Replace with your Google Maps API Key

  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

  try {
    const response = await axios.get(url);

    if (response.data.status === "OK") {
      const results = response.data.results;

      if (results.length > 0) {
        const addressComponents = results[0].address_components;


        const streetAddress = getStreetAddress(addressComponents);

        const subAddress = addressComponents.find((comp) => 
          comp.types.includes("administrative_area_level_2")
        )?.long_name;


        const city = addressComponents.find((comp) =>
          comp.types.includes("administrative_area_level_3")
        )?.long_name || addressComponents.find((comp) =>  
          comp.types.includes("locality"))?.long_name;

        const state = addressComponents.find((comp) =>
          comp.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = addressComponents.find((comp) =>
          comp.types.includes("country")
        )?.long_name;

        const zipcode = addressComponents.find((comp) =>
          comp.types.includes("postal_code")
        )?.long_name;


        return {
          city,
          state,
          country,
          zipcode,
          address: streetAddress || results[0].formatted_address, 
          subAddress// Fallback to formatted address if streetAddress is not available
        };
      } else {
        throw new Error("No results found");
      }
    } else {
      throw new Error("Geocoding API error: " + response.data.status);
    }
  } catch (error) {
    console.error("Error fetching geocode data:", error);
    throw error;
  }
}

export default GetAddressDetails;
